import { Match, Show, Switch, createSignal } from "solid-js";

import { usePlayer } from "~/components/PlayerContext";
import rootStyles from "~/components/Root.module.scss";
import Tooltip from "~/components/Tooltip";
import styles from "~/components/player/VolumeControl.module.scss";

export default function VolumeControl() {
  const player = usePlayer();
  const [previousVolume, setPreviousVolume] = createSignal(player.volume);

  const toggleVolume = (event: Event) => {
    event.stopPropagation();

    if (player.volume === 0) {
      window.jhplayer.volume = previousVolume();
      return;
    }

    setPreviousVolume(player.volume);
    window.jhplayer.volume = 0;
  };

  return (
    <Show when={player.volume !== -1}>
      <div class={styles.wrapper}>
        <Tooltip
          content="Volume"
          type="button"
          class={styles.button}
          onClick={toggleVolume}
        >
          <Switch fallback={<IconTablerVolume />}>
            <Match when={player.volume === 0}>
              <IconTablerVolume3 />
            </Match>
            <Match when={player.volume <= 0.5}>
              <IconTablerVolume2 />
            </Match>
          </Switch>
          <span class={rootStyles["sr-only"]}>Volume</span>
        </Tooltip>
        <div class={styles["slider-wrapper"]}>
          <input
            class={styles.slider}
            type="range"
            value={player.volume}
            max={1}
            step="any"
            aria-label="Controle de Volume"
            onInput={(event) => {
              window.jhplayer.volume = event.target.valueAsNumber;
            }}
          />
        </div>
      </div>
    </Show>
  );
}
